import refreshGoogleAds from '@gumtree/third-party-ads/src/refresh-google-ads';
import type { WindowWithGoogleTag } from '@gumtree/shared/src/types/window';

const OPEN_DIALOG = 'OPEN_DIALOG';
const CLOSE_DIALOG = 'CLOSE_DIALOG';
const IS_VIDEO = 'IS_VIDEO';

export const openDialog = (slideNumber: number) => {
    // @ts-ignore
    refreshGoogleAds(window as WindowWithGoogleTag, ['galleryBanner']);

    return {
        type: OPEN_DIALOG,
        payload: { isDialogOpen: true, slideNumber },
    };
};

export const closeDialog = () => ({
    type: CLOSE_DIALOG,
    payload: { isDialogOpen: false },
});

export const setIsVideo = (isVideo) => ({
    type: IS_VIDEO,
    payload: { isVideo },
});

const initialState = { isDialogOpen: false };

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case OPEN_DIALOG:
        case CLOSE_DIALOG:
        case IS_VIDEO:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
